import { useContext, useMemo } from "react";
import { ReactComponent as ProfileIcon } from "../../asset/icons/sidebar/profile.svg";
import { ReactComponent as SettingsIcon } from "../../asset/icons/sidebar/settings.svg";
import { ReactComponent as MessagesIcon } from "../../asset/icons/sidebar/messages.svg";
import { ReactComponent as ReportsIcon } from "../../asset/icons/sidebar/reports.svg";
import { ReactComponent as ClubIcon } from "../../asset/icons/sidebar/club.svg";
import { ReactComponent as SurveyIcon } from "../../asset/icons/sidebar/comment.svg";
import { ReactComponent as Restaurant } from "../../asset/icons/sidebar/restaurant.svg";
import { ReactComponent as OrganizationsIcon } from "../../asset/icons/sidebar/organizations.svg";
import { useTranslation } from "react-i18next";
import { GlobalStateContext } from "../../layouts/GlobalStates";
import { getOrganizationMenuItem, isParticipationEnabled } from "../../helperData/organizationSidebar";

function useSideBarList() {
    const { t } = useTranslation();
    const { auth } = useContext(GlobalStateContext);

    return useMemo(() => {
        const sidebar = [
            // {
            //     title: t("Dashboard.label"),
            //     icon: <DashboardIcon />,
            //     iconName: <DashboardIcon />,
            //     addressLink: "/dashboard/dashboard",
            // },
        ];
        const reports = getOrganizationMenuItem(
            auth,
            "reports",
            t("reports.title"),
            auth.company_admin && auth.package?.report_permission
        );
        const messages = getOrganizationMenuItem(
            auth,
            "messages",
            t("Messages.label"),
            !auth.company_admin ||
                (auth.company_admin && auth.package?.automation_permission)
        );
        const customerClub = getOrganizationMenuItem(
            auth,
            "customer_club",
            t("Customer.club.label"),
            isParticipationEnabled(auth)
        );
        const restaurant = getOrganizationMenuItem(
            auth,
            "restaurant",
            t("SalesAndServices.Label"),
            auth.company_admin &&
                (auth.package?.menu_permission ||
                    auth.package?.market_permission ||
                    auth.package?.discount_permission)
        );
        // Legacy configs may still enable market/points as separate keys.
        const legacyMarket = getOrganizationMenuItem(
            auth,
            "market",
            t("SellingCart.Label"),
            false
        );
        const legacyPoints = getOrganizationMenuItem(
            auth,
            "points",
            t("PointsManagment.label"),
            false
        );
        const salesAndServicesEnabled =
            restaurant.enabled || legacyMarket.enabled;
        const salesAndServicesTitle = restaurant.enabled
            ? restaurant.title
            : t("SalesAndServices.Label");
        const participationEnabled =
            customerClub.enabled || legacyPoints.enabled;
        const settings = getOrganizationMenuItem(
            auth,
            "settings",
            t("Settings.exp.label"),
            auth.company_admin && auth.package?.setting_permission
        );
        const survey = getOrganizationMenuItem(
            auth,
            "survey",
            t("survey.menu.label"),
            auth.company_admin && auth.package?.survey_permission
        );
        // Superuser-only organization management entry (shown after org menu items).
        const superuserOrganizations =
            Number(auth.usertype) === 1 || auth.is_superuser === true
                ? {
                      title: t("OrgManagement.Section.Title"),
                      icon: <OrganizationsIcon />,
                      iconName: <OrganizationsIcon />,
                      addressLink: "/dashboard/organizations",
                  }
                : null;

        if (auth.company_admin && reports.enabled) {
            sidebar.push({
                title: reports.title,
                icon: <ReportsIcon />,
                iconName: <ReportsIcon />,
                addressLink: "/dashboard/",
            });
        }
        if (messages.enabled) {
            sidebar.push({
                menuKey: "messages",
                title: messages.title,
                icon: <MessagesIcon />,
                iconName: <MessagesIcon />,
                addressLink: "/dashboard/messages/organ",
            });
        }
        if (auth.company_admin && survey.enabled) {
            sidebar.push({
                title: survey.title,
                icon: <SurveyIcon />,
                iconName: <SurveyIcon />,
                addressLink: "/dashboard/surveys",
            });
        }
        if (auth.company_admin && settings.enabled) {
            sidebar.push({
                title: settings.title,
                icon: <SettingsIcon />,
                iconName: <SettingsIcon />,
                addressLink: "/dashboard/exp-settings",
            });
        }
        if (auth.company_admin && participationEnabled) {
            sidebar.push({
                title: customerClub.title,
                icon: <ClubIcon />,
                iconName: <ClubIcon />,
                addressLink: "/dashboard/customer-club",
            });
        }
        if (auth.company_admin && salesAndServicesEnabled) {
            sidebar.push({
                title: salesAndServicesTitle,
                icon: <Restaurant />,
                iconName: <Restaurant />,
                addressLink: "/dashboard/sales/1",
            });
        }
        if (
            auth.company_admin ||
            Number(auth.usertype) === 1 ||
            auth.is_superuser === true
        ) {
            sidebar.push({
                title: t("Organizational.Profile.Sidebar.label"),
                icon: <ProfileIcon />,
                iconName: <ProfileIcon />,
                addressLink: "/dashboard/profile",
            });
        }
        if (superuserOrganizations) {
            sidebar.push(superuserOrganizations);
        }
        return sidebar;

        // return [
        //   {
        //     title: t("Dashboard.label"),
        //     icon: <DashboardIcon/>,
        //     iconName: <DashboardIcon/>,
        //     addressLink: "/dashboard/dashboard",
        //   },
        //   {
        //     title: t("Profile.label"),
        //     icon: <ProfileIcon/>,
        //     iconName: <ProfileIcon/>,
        //     addressLink: "/dashboard/profile",
        //   },
        //   {
        //     title: t("Messages.label"),
        //     icon: !auth.company_admin || (auth.company_admin && auth.package?.automation_permission) ? <MessagesIcon/> :
        //       <Lock/>,
        //     iconName: !auth.company_admin || (auth.company_admin && auth.package?.automation_permission) ? <MessagesIcon/> :
        //       <Lock/>,
        //     addressLink: "/dashboard/messages/organ",
        //   },
        //   {
        //     title: t("Report.label"),
        //     icon: auth.company_admin && auth.package?.report_permission ? <ReportsIcon/> : <Lock/>,
        //     iconName: auth.company_admin && auth.package?.report_permission ? <ReportsIcon/> : <Lock/>,
        //     addressLink: "/dashboard/report",
        //   },
        //   {
        //     title: t("Customer.club.label"),
        //     icon: auth.company_admin && auth.package?.club_permission ? <ClubIcon/> : <Lock/>,
        //     iconName: auth.company_admin && auth.package?.club_permission ? <ClubIcon/> : <Lock/>,
        //     addressLink: "/dashboard/customer-club",
        //   },
        //   {
        //     title: t("SellingCart.Label"),
        //     icon: auth.company_admin && auth.package?.market_permission ? <Basket/> : <Lock/>,
        //     iconName: auth.company_admin && auth.package?.market_permission ? <Basket/> : <Lock/>,
        //     addressLink: "/dashboard/market/1",
        //   },
        //   {
        //     title: t("PointsManagment.label"),
        //     icon: <ScoresIcon/>,
        //     iconName: <ScoresIcon/>,
        //     addressLink: "/dashboard/rating",
        //   },
        //   {
        //     title: t("Settings.label"),
        //     icon: auth.company_admin && auth.package?.setting_permission ? <SettingsIcon/> : <Lock/>,
        //     iconName: auth.company_admin && auth.package?.setting_permission ? <SettingsIcon/> : <Lock/>,
        //     addressLink: "/dashboard/settings",
        //   },
        // ];
    }, [auth, t]);
}

export default useSideBarList;
